export enum EPillarsUrls {
  PILLARS = 'pillars',
  FOCUSES = 'focuses',
  PILLARS_OF_STRENGTH = 'pillars-of-strength',
}
